/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linkcopiedtoclipboard3Inputs */

const en_linkcopiedtoclipboard3 = /** @type {(inputs: Linkcopiedtoclipboard3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The share link has been copied to your clipboard.`)
};

const de_linkcopiedtoclipboard3 = /** @type {(inputs: Linkcopiedtoclipboard3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Teilen-Link wurde in die Zwischenablage kopiert.`)
};

/**
* | output |
* | --- |
* | "The share link has been copied to your clipboard." |
*
* @param {Linkcopiedtoclipboard3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const linkcopiedtoclipboard3 = /** @type {((inputs?: Linkcopiedtoclipboard3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linkcopiedtoclipboard3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_linkcopiedtoclipboard3(inputs)
	return de_linkcopiedtoclipboard3(inputs)
});
export { linkcopiedtoclipboard3 as "linkCopiedToClipboard" }